// extracted by mini-css-extract-plugin
module.exports = {"divider":"form_divider__1LUdx"};